module.exports = __webpack_public_path__ + "img/raffle-banner.f4fa622c.jpg";